import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { OfferStatusCssClasses } from "../OffersUIHelpers";
import * as actions from "../../../_redux/offers/offersActions";
import { useOffersUIContext } from "../OffersUIContext";

const selectedOffers = (entities, ids) => {
  const _offers = [];
  ids.forEach((id) => {
    const offer = entities.find((el) => el._id === id);
    if (offer) {
        _offers.push(offer);
    }
  });
  return _offers;
};

export function OffersUpdateStateDialog({ show, onHide }) {
  // Offers UI Context
  const offersUIContext = useOffersUIContext();
  const offersUIProps = useMemo(() => {
    return {
      ids: offersUIContext.ids,
      setIds: offersUIContext.setIds,
      queryParams: offersUIContext.queryParams,
    };
  }, [offersUIContext]);

  // Offers Redux state
  const { offers, isLoading } = useSelector(
    (state) => ({
        offers: selectedOffers(
        state.offers.entities,
        offersUIProps.ids
      ),
      isLoading: state.offers.actionsLoading,
    }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!offersUIProps.ids || offersUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offersUIProps.ids]);

  const [type, setTypes] = useState("canceled");

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for update offers status by selected ids
    dispatch(actions.updateOffersStatus(offersUIProps.ids, type)).then(
      () => {
        // refresh list after deletion
        dispatch(actions.fetchOffers(offersUIProps.queryParams)).then(
          () => {
            // clear selections list
            offersUIProps.setIds([]);
            // closing delete modal
            onHide();
          }
        );
      }
    );
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Status Will be updated for selected Offers
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overlay overlay-block">
        {/*begin::Loading*/}
        {isLoading && (
          <div className="overlay-layer">
            <div className="spinner spinner-lg spinner-primary" />
          </div>
        )}
        {/*end::Loading*/}

        <div className="timeline timeline-5 mt-3">
          {offers.map((offer) => (
            <div
              className="timeline-item align-items-start"
              key={`offersUpdate${offer._id}`}
            >
              <div className="timeline-label font-weight-bolder text-dark-75 font-size-lg text-right pr-3" />
              <div className="timeline-badge">
                <i
                  className={`fa fa-genderless text-${
                    OfferStatusCssClasses[offer.type]
                  } icon-xxl`}
                />
              </div>
              <div className="timeline-content text-dark-50 mr-5">
                <span
                  className={`label label-lg label-light-${
                    OfferStatusCssClasses[offer.type]
                  } label-inline`}
                >
                  ID: {offer._id}
                </span>
                <span className="ml-3">
                  {offer._id}
                </span>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="form">
        <div className="form-group">
          <select
            className="form-control"
            value={type}
            onChange={(e) => setTypes(e.target.value)}
          >
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
            <option value="canceled">Chargebacks</option>
            <option value="on-hold">on-hold</option>

          </select>
        </div>
        <div className="form-group">
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate mr-3"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={updateStatus}
            className="btn btn-primary btn-elevate"
          >
            Update Status
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
